<template>
  <router-view></router-view>
</template>

<script> 
export default {
  name: "host-supply",
  data() {
    return {
    }
  },
}
</script>

<style scoped lang="scss">

</style>
